var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"field",attrs:{"id":"status"}},[(_vm.selectedStatus)?_c('Dropdown',{attrs:{"options":_vm.allowedStatusChoices,"selected":_vm.selectedStatus.name,"selection":_vm.selectedStatus},on:{"update:selection":function($event){_vm.selectedStatus=$event}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }